import { render } from "./StackedBarChart.vue?vue&type=template&id=0aaa8b30"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"
script.render = render

export default script